var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OCol',{staticClass:"ma-6",staticStyle:{"height":"500px"},attrs:{"stretch-xy":"","left":""}},[_c('OMap2',{ref:"theMap",style:({zIndex: 1}),attrs:{"markers":_vm.markers,"polygons":_vm.polygons,"showPOI":false,"maxZoom":20}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }